const dpiaMessages = require('../dpia/messages')

module.exports = Object.assign({}, dpiaMessages, {
  //law enforcement specific messages;
})
